<div class="px-3 md:px-4 md:py-0 sm:py-0 max-w-[900px] mx-auto">
  <!-- Header -->
  <header class="mb-6 flex items-start gap-3">
    @if (isSmallScreen()) {
      <button
        mat-icon-button
        class="w-10 h-10 rounded-xl bg-white border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:bg-gray-50 transition-colors shrink-0 mt-0.5"
        (click)="sidenavService.toggle()"
        [matTooltip]="(sidenavService.opened() ? 'Global.Close' : 'Global.Open') | translate"
      >
        <mat-icon class="text-[20px]! w-5! h-5!">{{ sidenavService.opened() ? 'left_panel_close' : 'left_panel_open' }}</mat-icon>
      </button>
    }
    <div class="flex-1 min-w-0">
      <h1 class="text-2xl font-bold mb-1">{{ 'Templates.ManageTemplates' | translate }}</h1>
      <p class="text-sm text-gray-500">{{ 'Templates.ManageTemplatesDesc' | translate }}</p>
    </div>
  </header>

  <!-- Main Card -->
  <div class="bg-white rounded-2xl border border-gray-200 mb-8 overflow-hidden">
    <!-- Toolbar -->
    <div class="p-3 border-b border-gray-100 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      <div class="relative flex-1">
        <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-[18px]! w-[18px]! h-[18px]!">search</mat-icon>
        <input
          class="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#5a73c5]/20 focus:border-[#5a73c5] transition-all placeholder:text-gray-400"
          [(ngModel)]="searchTerm"
          (keyup)="filter()"
          [placeholder]="'Templates.SearchPlaceholder' | translate"
        />
      </div>

      @if (userIsNotReader()) {
        <button mat-flat-button color="primary" (click)="createTemplate()" class="sm:shrink-0">
          <mat-icon>add</mat-icon>
          {{ 'Templates.CreateButton' | translate }}
        </button>
      }
    </div>

    @if (loading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <!-- Content -->
    <div class="max-h-[calc(100vh-340px)] overflow-y-auto custom-scrollbar p-3 flex flex-col gap-2">
      @if (displayedTemplates.length === 0 && !loading) {
        <div class="flex flex-col items-center justify-center py-16 px-6 text-gray-500">
          <mat-icon class="text-4xl w-12 h-12 mb-3 opacity-50">network_intel_node</mat-icon>
          <p class="text-sm m-0">{{ 'Templates.NoModelsFound' | translate }}</p>
        </div>
      }

      @for (element of displayedTemplates; track element) {
        <div
          class="group rounded-xl border transition-all duration-200 overflow-hidden cursor-pointer"
          [class]="
            expandedId === element._id ? 'border-gray-300 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.04)]' : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-[0_2px_8px_rgba(0,0,0,0.04)]'
          "
        >
          <!-- Row — clickable -->
          <div class="flex items-center gap-4 p-4" (click)="toggleExpand(element._id)">
            <!-- Icon -->
            <div class="w-10 h-10 rounded-lg bg-[#5a73c5]/5 flex items-center justify-center shrink-0 text-[#5a73c5]">
              <mat-icon class="text-[18px]! w-[18px]! h-[18px]!">description</mat-icon>
            </div>

            <!-- Name -->
            <div class="flex flex-col min-w-0 flex-1">
              <span class="text-sm font-bold text-gray-800 truncate">{{ element.name }}</span>
              <span class="text-[13px] text-gray-500 truncate mt-0.5">{{ 'Templates.ClickToExpand' | translate }}</span>
            </div>

            <!-- Chevron -->
            <mat-icon class="text-gray-400 text-[18px]! w-[18px]! h-[18px]! transition-transform duration-200" [class.rotate-180]="expandedId === element._id">expand_more</mat-icon>
          </div>

          <!-- Expanded Content -->
          <div class="overflow-hidden transition-all duration-200 ease-in-out" [class]="expandedId === element._id ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'">
            <div class="px-4 pb-4">
              <div class="ml-14 border-t border-gray-200/60 pt-4">
                <!-- Description -->
                <div class="text-[13px] leading-relaxed text-gray-600 mb-4 model-content" [innerHTML]="element.data"></div>

                <!-- Actions -->
                @if (userIsNotReader()) {
                  <div class="flex items-center justify-end gap-2">
                    <button mat-button (click)="deleteTemplate(element, $event); $event.stopPropagation()">
                      {{ 'Global.Delete' | translate }}
                    </button>
                    <button mat-button btnType="action" (click)="openTemplate(element); $event.stopPropagation()">
                      {{ 'Global.Edit' | translate }}
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Footer / Paginator -->
    @if (totalSize > pageSizeOptions[0]) {
      <div class="border-t border-gray-100 px-4 py-2">
        <app-custom-paginator [pageSizeOptions]="pageSizeOptions" [totalLength]="totalSize" (page)="onPageChange($event)" [(currentPage)]="pageIndex" [type]="'models'"></app-custom-paginator>
      </div>
    }
  </div>
</div>
